import { CopySimpleIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Duplicate = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CopySimpleIcon {...rest} size={Sizes[size]} color={fill} />;
};

Duplicate.displayName = 'Duplicate';
